export { default as WidgetModel } from './WidgetModel';



// WEBPACK FOOTER //
// ./~/@girder/slicer_cli_web/models/index.js